import {ApiClient} from "../generated/ApiClient";
import {Aborted, useFetcher} from "./useFetcher";
import {FrontWebUserLikedModel, ResponseError} from "../generated";

export const useMyKey = (page:number) => ({
    queryKey: ["useMyKey", page, "my"],
    queryFn: useFetcher(() => new ApiClient().getApiSearchRadioMy({ page: page }, { credentials: "include"})),
});

export const useMyRadioKey =  (slug: string, enabled: boolean) => ({
    queryKey: ["useMyRadio", slug, "my", enabled],
    queryFn: useFetcher(() => enabled ? new ApiClient().getApiUserIsLikedStations({
        stations: [slug]
    },{
        credentials: "include",
        signal: Aborted().signal
    }).catch(e=> {
        if (e instanceof ResponseError  && (e.response.status === 401 || e.response.status === 404))
        {
            return [] as FrontWebUserLikedModel[]
        }
        throw e;
    }) : Promise.resolve([] as FrontWebUserLikedModel[]))
})